import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isInTalentPool } from 'redux/modules/portfolio';
import SvgIcon from 'components/SvgIcon/SvgIcon';

import styles from './InTalentPoolIcon.module.scss';

/**
 * Read-only indicator that shows a heart when the given user is in the current
 * client's talent pool. No button or click handler.
 */
const InTalentPoolIcon = ({
  user,
  username: usernameProp,
  size = 18,
  className = '',
}) => {
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.auth && state.auth.user);
  const username =
    usernameProp || (user && (user.username || user.displayname));

  // Talent pool state for this user from Redux portfolio slice
  const talentPoolState = useSelector(
    (state) => username && state.portfolio && state.portfolio[username]
  );

  const isInTalentPoolValue =
    talentPoolState && typeof talentPoolState.isInTalentPool !== 'undefined'
      ? talentPoolState.isInTalentPool
      : false;

  // Ensure talent pool state is loaded for the current user when logged in
  useEffect(() => {
    if (!username || !authUser) {
      return;
    }

    if (
      !talentPoolState ||
      (typeof talentPoolState.isInTalentPool === 'undefined' &&
        !talentPoolState.loadingShortlistState)
    ) {
      dispatch(isInTalentPool(username));
    }
  }, [authUser, dispatch, talentPoolState, username]);

  if (!username) {
    return null;
  }

  // Not in talent pool – hide indicator
  if (!isInTalentPoolValue) {
    return null;
  }

  // Show heart only when the user is in the talent pool
  return (
    <span className={className || styles.favouriteIndicator} aria-hidden>
      <SvgIcon icon="heart" size={size} color="#D9534F" />
    </span>
  );
};

InTalentPoolIcon.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
    displayname: PropTypes.string,
  }),
  username: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
};

export default InTalentPoolIcon;
